
import React from 'react'
import { AccordionContainer } from '../../../../../../common/components/accordion/accordion.module'
import { InputLabelContainer } from '../../../../../../common/components/form/label/containers/input-label.container'
import Table from '../../../../../../common/components/table'

export default function LogisticsQuoteItemomponent({ columnDefs, quoteDetails, rowData }: any) {

  return (
    <>
      <AccordionContainer
        child={
          <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
            <div>
              <InputLabelContainer
                label="currency"
              />
              <InputLabelContainer
                label={quoteDetails?.quote?.price?.currency}
              /></div>
            <div>
              <InputLabelContainer
                label="price"
              />
              <InputLabelContainer
                label={quoteDetails?.quote?.price?.value}
              />
            </div>
          </div>
        }
        expandedPanel="breakupInfo"
        headerTitle="Quote Price Info"
      />
      <Table
        columnData={columnDefs}
        rowData={rowData}
      />
    </>
  )
}